import React from 'react';

import './App.css';
import CurrentPage from './CurrentPage';
import MainHeader from './MainHeader';
import MainFooter from './MainFooter';
import MainPage from './MainPage';
import { useSkiLogic } from './useSkiLogic';

/*const HomePage = () => (
  <div className="App">
    <MainHeader />
    <MainPage />
    <MainFooter />
  </div>
);

const AboutPage = () => (
  <div className="App">
    <MainHeader />
    <About />
    <MainFooter />
  </div>
);

const ContactPage = () => (
  <div className="App">
    <MainHeader />
    <Contact />
    <MainFooter />
  </div>
);

const AnotherDomainPage = () => (
  <div className="App">
    <MainHeader />
    <AnotherDomain />
    <MainFooter />
  </div>
);

const BeyondCloudflarePage = () => (
  <div className="App">
    <MainHeader />
    <BeyondCloudflare />
    <MainFooter />
  </div>
);

const Cloudflare1xxxErrorsPage = () => (
  <div className="App">
    <MainHeader />
    <Cloudflare1xxxErrors />
    <MainFooter />
  </div>
);

const GameOriginDnsError1016FixPage = () => (
  <div className="App">
    <MainHeader />
    <GameOriginDnsError1016Fix />
    <MainFooter />
  </div>
);

const NetworkError1016Page = () => (
  <div className="App">
    <MainHeader />
    <NetworkError1016 />
    <MainFooter />
  </div>
);

const OriginDnsSolutionPage = () => (
  <div className="App">
    <MainHeader />
    <OriginDnsSolution />
    <MainFooter />
  </div>
);

const PartialZoneSolvedPage = () => (
  <div className="App">
    <MainHeader />
    <PartialZoneSolved />
    <MainFooter />
  </div>
);

const Secured1016OriginDnsPage = () => (
  <div className="App">
    <MainHeader />
    <Secured1016OriginDns />
    <MainFooter />
  </div>
);

const StreamError1016SolutionsPage = () => (
  <div className="App">
    <MainHeader />
    <StreamError1016Solutions />
    <MainFooter />
  </div>
);

const PrivacyPracticePage = () => (
  <div className="App">
    <MainHeader />
    <PrivacyPractice />
    <MainFooter />
  </div>
);

const ThirdPartySolutionsPage = () => (
  <div className="App">
    <MainHeader />
    <ThirdPartySolutions />
    <MainFooter />
  </div>
);

const PrivacyRightsPage = () => (
  <div className="App">
    <MainHeader />
    <PrivacyRights />
    <MainFooter />
  </div>
);

const CalendarYearPrivacyPage = () => (
  <div className="App">
    <MainHeader />
    <CalendarYearPrivacy />
    <MainFooter />
  </div>
);*/

// 2. Map the URL paths to your page components
/*const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/another_domain',
    element: <AnotherDomainPage />,
  },
  {
    path: '/beyond_cloudflare',
    element: <BeyondCloudflarePage />,
  },
  {
    path: '/cloudflare_1xxx_errors',
    element: <Cloudflare1xxxErrorsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/game_origins_dns_error_1016_fix',
    element: <GameOriginDnsError1016FixPage />,
  },
  {
    path: '/network_error_1016',
    element: <NetworkError1016Page />,
  },
  {
    path: '/origin_dns_solution',
    element: <OriginDnsSolutionPage />,
  },
  {
    path: '/partial_zone_solved',
    element: <PartialZoneSolvedPage />,
  },
  {
    path: '/secured_1016_origin_dns',
    element: <Secured1016OriginDnsPage />,
  },
  {
    path: '/stream_error_1016_solutions',
    element: <StreamError1016SolutionsPage />,
  },
  {
    path: '/privacy_practice',
    element: <PrivacyPracticePage />,
  },
  {
    path: '/third_party_solutions',
    element: <ThirdPartySolutionsPage />,
  },
  {
    path: '/privacy_rights',
    element: <PrivacyRightsPage />,
  },
  {
    path: '/calendar_year_privacy',
    element: <CalendarYearPrivacyPage />,
  },
]);*/

// 3. Render the provider
export default function App() {
  return <CurrentPage />;
}
